import React from 'react';

import SpecTool from '../../spec-tool';

function StoryblokSpecToolAdapter(props) {
  return <SpecTool {...props} />;
}

export default StoryblokSpecToolAdapter;
